import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

/* Core */
import { CoreModule } from './core/core.module';
/* App routing */
import { AppRoutingModule } from './routing.module';
/* Bootstrap component */
import { AppComponent } from './app.component';
import {NgSelectModule} from '@ng-select/ng-select';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    AppRoutingModule,
    NgSelectModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts